export default __webpack_public_path__ + "static/media/icon_bag.9bdde4d4.svg";